import { LoanDocState, TaskState } from 'gql/graphql';
import { Phases } from 'scenes/Private/Dashboard/LoanPhases.constanst';

// SVG imports
import homeWhiteEmptySvg from 'assets/images/home-white-empty.svg';
import homeBlackEmptySvg from 'assets/images/home-black-empty.svg';
import homeGreenSvg from 'assets/images/home-green-all.svg';
import homeErrorEmptySvg from 'assets/images/home-error-empty.svg';
import homeReviewEmptySvg from 'assets/images/home-review-empty.svg';

/**
 * Determinar el estado de la fase
 */
export const determinePhaseState = (
  rulesTaskCards: any[],
  loanDocs: any[],
  phase: any
): { state: string; stateName: string } => {
  
  if (phase.key === Phases.PRE_APPROVAL) {
    return { state: 'complete', stateName: 'COMPLETE' };
  }
  
  // Fase sin tasks
  if(phase.tasksItems?.length === 0) {
    const isCompleted = phase.lenderTasks?.every((item: any) => item.state === TaskState.Approved);
    
    if (isCompleted) return { state: 'complete', stateName: 'COMPLETE' };
  }

  const loanDocRef = loanDocs?.find(item =>
    item.state === LoanDocState.Blocking &&
    rulesTaskCards.find(item2 =>
      item2.state !== TaskState.Approved &&
      item2.state !== TaskState.Review &&
      item2.key.includes(item.key)
    )
  );

  const isBlocking = !!loanDocRef;
  const isCompleted = rulesTaskCards.length > 0 &&
    rulesTaskCards.every(item => item.state === TaskState.Approved);
  const isProgress = rulesTaskCards.length > 0 &&
    rulesTaskCards.find(item => (
      item.state === TaskState.Review || 
      item.state === TaskState.Approved || 
      item.state === TaskState.Incomplete
    ));
  const isError = rulesTaskCards.find(item => item.state === TaskState.RequestError);

  if (isCompleted) return { state: 'complete', stateName: 'COMPLETE' };
  if (isBlocking) return { state: 'blocked', stateName: 'BLOCKED' };
  if (isProgress) return { state: 'progress', stateName: 'IN PROGRESS' };
  if (isError) return { state: 'error', stateName: 'REJECTED' };
  
  return { state: 'not-started', stateName: 'NOT STARTED' };
};

export const getTaskIcon = (taskState: string, phaseState: string): string => {
  switch (taskState) {
    case TaskState.Approved:
      return homeGreenSvg;
    case TaskState.RequestError:
      return homeErrorEmptySvg;
    case TaskState.Review:
      return homeReviewEmptySvg;
    default:
      return phaseState === 'not-started' ? homeBlackEmptySvg : homeWhiteEmptySvg;
  }
};